import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhonePipe } from './phone/phone.pipe';
import { CapitalizeNamePipe } from './capitalize-name/capitalize-name.pipe';
import { DisplayDatePipe } from './display-date/display-date.pipe';

@NgModule({
  declarations: [PhonePipe, CapitalizeNamePipe, DisplayDatePipe],
  imports: [CommonModule],
  exports: [PhonePipe, CapitalizeNamePipe, DisplayDatePipe],
})
export class PipesModule {}
